<template>
    <v-row justify="center">
        <v-dialog
            v-model="modal"
            :persistent='true'
            width="50%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="pageTitle" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="form"
                            v-model="valid"
                            :lazy-validation="lazy"
                            >
                            <v-container>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">ゴルフ場</div>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            :items="golfCourses"
                                            item-value="golf_code"
                                            item-text="golf_name"
                                            v-model="input.golfCode"
                                            label="ゴルフ場名"
                                            :rules="[rules.required]"
                                            :disabled="true"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">コース</div>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            :items="courses"
                                            item-value="course_code"
                                            item-text="course_name"
                                            v-model="input.courseCode"
                                            label="コース"
                                            :rules="[rules.required]"
                                            :disabled="true"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">期間</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            class="px-3"
                                            maxlength="10"
                                            v-model="input.playDateStart"
                                            :disabled="true"
                                        />
                                    </v-col>
                                    <v-col cols="3">
                                    <v-text-field
                                            class="px-3"
                                            v-model="input.playDateValid"
                                            maxlength="10"
                                            :disabled="true"
                                        />
                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                                <v-row class="flex-nowrap">
                                    <div class="cardWrap__fromArea__title">開始時刻</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            class="px-3"
                                            :rules="[rules.required]"
                                            v-model="input.playTimeStart"
                                            type="time"
                                            maxlength="5"
                                        />
                                    </v-col>
                                    <div class="cardWrap__fromArea__title">終了時刻</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            class="px-3"
                                            :rules="[
                                                rules.required,
                                                rules.check_start_time
                                            ]"
                                            v-model="input.playTimeValid"
                                            type="time"
                                            maxlength="5"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔１</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            :rules="[
                                                rules.required,
                                                rules.check_int
                                            ]"
                                            class="px-3"
                                            v-model="input.interval1"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔２</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            class="px-3"
                                            v-model="input.interval2"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                            :disabled="disabledInterval2"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔３</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            class="px-3"
                                            v-model="input.interval3"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                            :disabled="disabledInterval3"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                        <v-btn color="green darken-4" text @click="validateCheck">時間変更</v-btn>
                    </v-card-actions>
                    <ChangeOverlay
                        @processing="createCellInfoData()"
                        @cancel="overlayClose()"
                        :processResult="process"
                        :OverlaySwitch="changeOverlay"
                        page-name="時間"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { utilityMixin } from '@/mixins/utility';
import validater from '@/lib/validater';
// コンポーネント
import CardTitle from '@/components/module/CardTitle';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';

// graphql
import {
    GET_PLAY_DATE_MAX_MIN,
    CREATE_CELL_INFO_DATA
} from '@/constants/cell_info';
import { GET_COURSE_LIST } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    mixins: [
        utilityMixin
    ],
    props: {
        golfCourses: {
            type: Array,
            required: true
        },
        playDate: {
            type: String
        },
        modal: {
            type: Boolean
        },
        received: {
            type: Object
        }
    },
    data () {
        return {
            pageTitle: '時間変更',
            // ゴルフグループコード
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            // 必須項目に関するチェック値
            valid: true,
            // バリデーションチェック値
            lazy: true,
            // コースリスト
            courses: [],
            // 入力値管理用
            input: {
                // ゴルフコード
                golfCode: '',
                // コースコード
                courseCode: '',
                // 期間From
                playDateStart: '',
                // 期間to
                playDateValid: '',
                // 開始時刻
                playTimeStart: '',
                // 終了時刻
                playTimeValid: '',
                // 間隔
                interval: '',
                interval1: '',
                interval2: '',
                interval3: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理状態
                processing: false
            },
            rules: {
                // 氏名（姓）バリデーション
                required: value => !!value || this.$t('error.validation.required.any'),
                check_start_time: value => this.checkCorrectTimeHours(value) || this.$t('error.validation.time.correct'),
                check_int: value => validater.checkIntType(value) || this.$t('error.validation.intType')
            }
        };
    },
    watch: {
        'input.golfCode' (val) {
            this.getCourseList();
        },
        received: {
            handler (val) {
                // this.Initialize();
                this.input.golfCode = val.golfCourse;
                this.input.courseCode = val.course;
                this.input.playDateStart = val.playDate;
                this.input.playDateValid = val.playDate;
            },
            deep: true
        },
        /** ----------------------------------------------
         * 画面を開く際に詳細情報を取得
         * ---------------------------------------------- */
        modal (val) {
            if (val) {
                this.getDetail();
            }
        },
        /** ----------------------------------------------
         * interval2が空なら、interval3を空にする。
         * ---------------------------------------------- */
        'input.interval2' (val) {
            if (val === '') {
                this.input.interval3 = '';
            }
        }
    },
    computed: {
        disabledInterval2 () {
            return !this.input.interval1;
        },
        disabledInterval3 () {
            return !(this.input.interval1 && this.input.interval2);
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.$set(this.input, 'golfCode', '');
            this.$set(this.input, 'courseCode', '');
            this.$set(this.input, 'playDateStart', '');
            this.$set(this.input, 'playDateValid', '');
            this.$set(this.input, 'playTimeStart', '');
            this.$set(this.input, 'playTimeValid', '');
            this.$set(this.input, 'interval', '');
            this.$set(this.input, 'interval1', '');
            this.$set(this.input, 'interval2', '');
            this.$set(this.input, 'interval3', '');
            this.process.result = '';
            this.process.resultText = '';
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * 詳細取得
         * ---------------------------------------------- */
        getDetail () {
            this.$apollo.query({
                query: GET_PLAY_DATE_MAX_MIN,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode,
                    course_code: this.input.courseCode,
                    play_date: this.input.playDateStart
                }
            }).then(res => {
                const detail = res.data.GetPlayDateMaxMin;
                if (!detail.min_play_start && !detail.max_play_start) {
                    this.input.playTimeStart = '00:00';
                    this.input.playTimeValid = '00:00';
                } else {
                    this.input.playTimeStart = detail.min_play_start;
                    this.input.playTimeValid = detail.max_play_start;
                }
            }).catch(e => {
                this.result = e;
                this.resultText = e;
            });
        },
        /** --------------------------------------------
         * コースを取得
         *-------------------------------------------- */
        async getCourseList () {
            this.$apollo.query({
                query: GET_COURSE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode
                }
            }).then(res => {
                this.courses = res.data.GetCoursesList;
            }).catch(e => {
                this.error = e;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                this.changeOverlay = true;
            }
        },
        /** --------------------------------------------
         * 入力値をセット
         *-------------------------------------------- */
        setInterval (data) {
            let arr = [];
            let dispInterval = '';
            if (data.interval1) {
                arr[1] = data.interval1;
                dispInterval = data.interval1;
                if (data.interval2) {
                    arr[2] = data.interval2;
                    dispInterval = dispInterval + '-' + data.interval2;
                    if (data.interval3) {
                        arr[3] = data.interval3;
                        dispInterval = dispInterval + '-' + data.interval3;
                    }
                }
                arr[0] = dispInterval;
            }

            const str = JSON.stringify(arr);
            return str;
        },
        /** --------------------------------------------
         * 入力値をセット
         *-------------------------------------------- */
        setInputInterval (data, int) {
            const str = JSON.parse(JSON.stringify(data));
            const obj = JSON.parse(str);
            if (obj[int]) {
                return obj[int];
            } else {
                return '';
            }
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        overlayClose () {
            this.changeOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        createCellInfoData () {
            this.$store.commit('loading/setIsLoading', true);

            this.$apollo.mutate({
                mutation: CREATE_CELL_INFO_DATA,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode,
                    course_code: this.input.courseCode,
                    play_date_start: this.input.playDateStart,
                    play_date_valid: this.input.playDateValid,
                    play_time_start: this.input.playTimeStart,
                    play_time_valid: this.input.playTimeValid,
                    interval: this.setInterval(this.input)
                }
            }).then(res => {
                this.result = res.data.createCellInfoData.result;
                this.$store.commit('loading/setIsLoading', false);
                this.overlayClose();
                this.closeModal();
            }).catch(e => {
                const errorMessage = e.message.split(/:/g);
                this.result = errorMessage;
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', '登録に失敗しました。');
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** --------------------------------------------
         * 終了時刻が開始時刻より前になっていないか
         * -------------------------------------------- */
        checkCorrectTimeHours () {
            if (this.input.playTimeStart && this.input.playTimeValid) {
                const start = this.formatTimeString(this.input.playTimeStart);
                const end = this.formatTimeString(this.input.playTimeValid);
                return Number(start) < Number(end);
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 時間フォーマット
         * 例 07:00:00 → 0700
         * ---------------------------------------------- */
        formatTimeString (item) {
            return item.split(':').splice(0, 2).join('');
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            this.overlayClose();
            this.$emit('refresh-event');
            this.$refs.form.resetValidation();
            this.Initialize();
        }
    }
};
</script>
